import { DateInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

const RecebimentoDiferentePrimeiraCobranca = ({ values, handleChange, handleBlur, errors }) => {
  const formikContext = useFormikContext();

  const { setErrors, setTouched } = formikContext;
  useEffect(() => {
    setTouched({});
    setErrors({});
  }, [values.recebimentoDiferentePrimeiraCobranca, setErrors, setTouched]);

  return (
    <>
      <Grid container spacing={2} className="mt-16 mb-16">
        <Grid item xs={4}>
          <FormControlLabel
            label="Recebimento diferente na 1ª cobrança? "
            disabled={
              values?.possuiCobrancaBaixadaOuRemessaGerada ||
              values?.possuiNotaTransmitida ||
              values.periodicidade === 'ANUAL'
            }
            control={
              <Switch
                id="recebimentoDiferentePrimeiraCobranca"
                name="recebimentoDiferentePrimeiraCobranca"
                onChange={handleChange}
                value={values?.recebimentoDiferentePrimeiraCobranca}
                checked={values?.recebimentoDiferentePrimeiraCobranca}
                onBlur={handleBlur}
                size="small"
                color="primary"
              />
            }
          />
        </Grid>
        {values?.recebimentoDiferentePrimeiraCobranca && values?.periodicidade !== 'ANUAL' && (
          <>
            <Grid item xs={4}>
              <SelectInput
                id="formaRecebimentoPrimeiraCobranca"
                name="formaRecebimentoPrimeiraCobranca"
                label="Forma de recebimento da 1ª cobrança"
                labelId="formaRecebimentoPrimeiraCobranca"
                value={values?.formaRecebimentoPrimeiraCobranca}
                onBlur={handleBlur}
                onChange={handleChange}
                disableClearable={true}
                error={errors.formaRecebimentoPrimeiraCobranca}
                touched={!!errors.formaRecebimentoPrimeiraCobranca}
                required
                options={[
                  { id: 'BOLETO', title: 'Boleto' },
                  { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
                  { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
                  { id: 'CHEQUE', title: 'Cheque' },
                  { id: 'DINHEIRO', title: 'Dinheiro' },
                  { id: 'TED_DOC', title: 'TED/DOC' },
                  { id: 'PIX', title: 'PIX' },
                ]}
                disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
              />
            </Grid>
            <Grid item xs={4}>
              <DateInput
                id="dataVencimentoPrimeiraCobranca"
                name="dataVencimentoPrimeiraCobranca"
                label="Data do vencimento da 1ª cobrança"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.dataVencimentoPrimeiraCobranca}
                error={errors.dataVencimentoPrimeiraCobranca}
                helperText={errors.dataVencimentoPrimeiraCobranca}
                touched={!!errors.dataVencimentoPrimeiraCobranca}
                required
                fullWidth
                variant="outlined"
                disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default RecebimentoDiferentePrimeiraCobranca;
